import angular from 'angular'

import { toSrc } from './security'
import { getMediaInfo } from './post-info'
import { constant, castArray } from 'lodash-es'

angular
  .module('ggs.utils')
  .factory('fixYoutubeThumbInternal', fixYoutubeThumbInternalProvider)
  .factory('fixYoutubeThumb', fixYoutubeThumbProvider)

function fixYoutubeThumbProvider($q, fixYoutubeThumbInternal) {
  return function fixYoutubeThumb(input) {
    const posts = castArray(input)
    return $q.all(posts.map((post) => $q.all(post.media_list.map((media) => fixYoutubeThumbInternal(post, media))))).then(constant(input))
  }
}

function fixYoutubeThumbInternalProvider(
  $log,
  imgQueue) {

  const YT_THUMB_RE = /\/\w+\.\w+$/

  const YT_MID_QUAL = '/mqdefault.jpg' // always available, has not top\bottom bars, but has left\right bars
  const YT_MAX_QUAL = '/maxresdefault.jpg' // not always available, but always has not black bars

  const YT_DUMP_WIDTH = 120 // params of this thumb
  const YT_DUMP_HEIGHT = 90 // http://imgur.com/FZgmKv7

  return function fixYoutubeThumbInternal(post, media) {
    const mediaInfo = getMediaInfo(post, media)
    if (!mediaInfo.isYoutubeVideo) {
      return
    }

    const skip = media.hasOwnProperty('fix_youtube_thumbs')
    if (skip) {
      return
    }

    const midQual = toSrc(media.file_thumb.replace(YT_THUMB_RE, YT_MID_QUAL))
    const maxQual = toSrc(media.file_thumb.replace(YT_THUMB_RE, YT_MAX_QUAL))

    return imgQueue.stayInQueue(maxQual).then((imgSize) => {
      const isDumpThumb = true
        && imgSize.width === YT_DUMP_WIDTH
        && imgSize.height === YT_DUMP_HEIGHT

      if (isDumpThumb) {
        $log.debug(`fixYoutubeThumbInternal[id=${post.id}]: [maxQual=${maxQual}] is dump thumb! will use [midQual=${midQual}] instead!`)
        media.file_thumb = midQual
      } else {
        media.file_thumb = maxQual
      }
    }, (err) => {
      $log.debug(`fixYoutubeThumbInternal[id=${post.id}]: [maxQual=${maxQual}] is not available! will use [midQual=${midQual}] instead!`, err)
      media.file_thumb = midQual
    }).finally(() => {
      media.fix_youtube_thumbs = true
    })
  }
}
